import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';
import AuthOnly from '@/router/middleware/AuthOnly.tsx';
import ForcePasswordResetCheck from '@/router/middleware/ForcePasswordResetCheck.tsx';
import AuthCompanyAdmin from '@/router/middleware/AuthCompanyAdmin.tsx';
import AuthCompanyVerified from '@/router/middleware/AuthCompanyVerified.tsx';
import AuthCompanyEnabled from '@/router/middleware/AuthCompanyEnabled.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
    authOnly: <AuthOnly />,
    forceResetPasswordCheck: <ForcePasswordResetCheck />,
    authCompanyAdmin: <AuthCompanyAdmin />,
    authCompanyVerified: <AuthCompanyVerified />,
    authCompanyEnabled: <AuthCompanyEnabled />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
